import script from "./PatchworkCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./PatchworkCanvas.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__